import { getCountFromServer } from "firebase/firestore";
import { Repository } from "src/firebase/firestore/repository";
import { buildFilterQuery } from "src/firebase/firestore/filterQueryBuilderV3";
import { KarmaExchangeRequestedCountry } from "../types/requested-country.entity";

export class RequestedCountriesRepository extends Repository<KarmaExchangeRequestedCountry> {
  constructor() {
    super("karma_exchange_requested_countries");
  }

  async count(where?: any): Promise<number> {
    const filterQuery = await buildFilterQuery({
      collection: this.collection,
      where,
    });
    const countResult = await getCountFromServer(filterQuery);
    return countResult.data().count;
  }

  async countUnseen(): Promise<number> {
    const [totalCount, seenCount] = await Promise.all([
      this.count(),
      this.count({ isSeen: true }),
    ]);

    return Math.max(totalCount - seenCount, 0);
  }

  async markAllUnseenAsSeen(): Promise<void> {
    const unseenRequests: KarmaExchangeRequestedCountry[] = [];
    let offset: string | undefined;
    const pageSize = 100;

    while (true) {
      const batch = await this.find({
        offset,
        limit: pageSize,
        orderBy: ["createdAt", "desc"],
      });

      if (!batch.length) {
        break;
      }

      unseenRequests.push(...batch.filter((request) => request.isSeen !== true));

      if (batch.length < pageSize) {
        break;
      }

      offset = batch[batch.length - 1].id;
    }

    if (!unseenRequests.length) {
      return;
    }

    await Promise.all(
      unseenRequests.map((request) =>
        this.update(request.id, {
          isSeen: true,
        })
      )
    );
  }
}

export const requestedCountriesRepository = new RequestedCountriesRepository();
